/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { Typography2 } from '@coursera/cds-core';
import { ThumbsUpFilledIcon } from '@coursera/cds-icons';

import KeyInformationDetailsItem from 'bundles/unified-description-page-common/components/modules/key-information/KeyInformationDetailsItem';

import _t from 'i18n!nls/xdp';

type Props = {
  averageContentSatisfactionScore?: number | null;
  subtitle?: string;
};

const styles = {
  titleContainer: css`
    display: inline;
  `,
  thumbsUpContainer: css`
    vertical-align: middle;
    padding-right: var(--cds-spacing-50);
  `,
};

const KeyInformationCourseSatisfactionScore = ({ averageContentSatisfactionScore, subtitle }: Props) => {
  if (!averageContentSatisfactionScore) return null;
  const roundedSatisfactionScore = Math.round(averageContentSatisfactionScore);

  return (
    <KeyInformationDetailsItem
      title={
        <div css={styles.titleContainer}>
          <span css={styles.thumbsUpContainer}>
            <ThumbsUpFilledIcon color="interactive" />
          </span>
          <Typography2 component="span" variant="subtitleLarge">
            {`${roundedSatisfactionScore}%`}
          </Typography2>
        </div>
      }
      subtitle={subtitle ?? _t('Most learners liked this course')}
      modalTitle={_t('Thumbs up #{satisfactionScore}%', {
        satisfactionScore: roundedSatisfactionScore,
      })}
    />
  );
};

export default KeyInformationCourseSatisfactionScore;
